
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/report",
      function () {
        return require("private-next-pages/report/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/report"])
      });
    }
  